"use client";

import { useSEOContent } from "@/providers/seo-content-provider";
import { useEffect, useRef, type ReactNode } from "react";

interface SEOContentSetterProps {
	content: ReactNode;
	/** Optional stable key to control when content updates. If not provided, content will only be set once on mount. */
	contentKey?: string;
}

export function SEOContentSetter({ content, contentKey }: SEOContentSetterProps) {
	const { setSeoContent } = useSEOContent();
	const latestContent = useRef(content);
	latestContent.current = content;

	useEffect(() => {
		// Set content on mount or when contentKey changes
		setSeoContent(latestContent.current);

		// Cleanup on unmount
		return () => setSeoContent(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contentKey, setSeoContent]); // Only depend on stable key, not content itself

	return null; // This component doesn't render anything
}
